// export const baseURL = "http://api-uat.opptimise.in/"
// export const reportPdfURL = "http://reports-uat.opptimise.in/"
// export const reportPdfURL = "https://opptimise-reports-uat.pacewisdom.in/"
export const reportPdfURL = "https://reports.opptimise.in/"






// WEBPACK FOOTER //
// ./src/new/Utils/baseApi.js